export default __webpack_public_path__ + "static/media/verticalogo.2a2a1cfc.png";